/**
 * MODULE: _shared/frontend-shell/src/layout/mobile/MobilePageScope.tsx
 * PURPOSE: Wraps routed page content; applies mobile-page-scope for global CSS when on mobile shell.
 * PUBLIC_API: MobilePageScope
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 30 / 100
 */

import type { ReactNode } from 'react';

export type MobilePageScopeProps = {
  children: ReactNode;
  isMobileShell: boolean;
};

export function MobilePageScope({ children, isMobileShell }: MobilePageScopeProps) {
  return (
    <div
      className="flex min-h-0 min-w-0 flex-1 flex-col"
      data-mobile-page-scope={isMobileShell ? 'true' : 'false'}
    >
      {children}
    </div>
  );
}
